export interface SelectFieldOption {
  label: string;
  value: string;
}

export interface SelectFieldProps {
  id: string;
  label: string;
  value: string;
  options: SelectFieldOption[];
  disabled?: boolean;
  statusText?: string;
  onChange?: (value: string) => void;
}

export const SelectField = ({ disabled, id, label, onChange, options, statusText, value }: SelectFieldProps) => (
  <label className="mgo-stack mgo-gap-xs mgo-text-s mgo-weight-strong mgo-color-neutral" htmlFor={id}>
    {label}
    <select
      className="select-control"
      disabled={disabled}
      id={id}
      value={value}
      onChange={(event) => onChange?.(event.target.value)}
      style={{ minHeight: '42px', width: '100%' }}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
    {statusText && <span className="mgo-text-s mgo-weight-regular mgo-color-critical">{statusText}</span>}
  </label>
);